import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AuthenticationRoutingModule } from './authentication/authentication-routing.module';
import { Error404Component } from './pages/error404/error404.component';
import { PagesRoutingModule } from './pages/pages.routing';

const routes: Routes = [
  { path: '', redirectTo: '/sistema', pathMatch: 'full'}

  
  
];


@NgModule({
 
  imports: [
    RouterModule.forRoot(routes),
    PagesRoutingModule,
    AuthenticationRoutingModule
  ],
  exports : [

     RouterModule
  ]
})
export class AppRouterModule { }